export default "/assets/images/chart-04.svg?aed722597bc5dd650f2ebaddc15b3bcc";